"use strict";
var $ = require("../internals/export");
var lastIndexOf = require("../internals/array-last-index-of");
$({ target: "Array", proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf
});
